import React from 'react';
import {Outlet} from "react-router";
import CookieConsent from "../components/CookieConsent";
import Header from "../components/Header";
import Footer from "../components/Footer";

export const navigation = {
    "home": "Főoldal",
    "about": "Rólunk",
    "price": "Áraink",
    "contact": "Kapcsolat"
}

function App() {
    return <React.Fragment>
        <CookieConsent/>
        <Header/>
        <main>
            <Outlet/>
        </main>
        <Footer/>
    </React.Fragment>
}

export default App;